import React from "react";
import { useHistory } from "react-router-dom";

const Header = () => {
  const history = useHistory();
  return (
    <header className="grey hidden-print">
      <a onClick={() => history.push("/")} className="logo_image">
        <span className="hidden-480"></span>
      </a>
      <ul className="header_actions">
        <li className="responsive_menu">
          <a className="iconic">
            <i className="fa fa-bars"></i>
          </a>
        </li>
      </ul>
    </header>
  );
};
export default Header;
